import React from "react";
import PropTypes from "prop-types";
import { IoCloudUpload } from "react-icons/io5";
import { FileUploadWrapper } from "../Logistics.styled";
import MiniLoader from "../../../layout/miniLoader";

const FileUpload = ({ name, isDisabled, fileInfo, accept, isLoading, handleChange }) => {
	return (
		<FileUploadWrapper>
			{fileInfo ? (
				<a href={fileInfo.url} target='_blank' rel='noreferrer' className='truncate'>
					{fileInfo.fileName}
				</a>
			) : (
				<p>---</p>
			)}
			<button
				onClick={() => document.getElementById(`${name}`).click()}
				disabled={isLoading || isDisabled}
				style={{ color: isDisabled ? "#b8c8cf" : "#003a50" }}>
				{isLoading ? <MiniLoader /> : <IoCloudUpload size={20} />}
			</button>
			<input
				type='file'
				id={name}
				name={name}
				style={{ visibility: "hidden", position: "absolute" }}
				disabled={isDisabled || isLoading}
				accept={accept || "image/*,.pdf,.doc,.docx"}
				onChange={handleChange}
			/>
		</FileUploadWrapper>
	);
};

FileUpload.propTypes = {
	name: PropTypes.string,
	fileInfo: PropTypes.object,
	accept: PropTypes.string,
	isDisabled: PropTypes.bool,
	isLoading: PropTypes.bool,
	handleChange: PropTypes.func,
};

export default FileUpload;
